var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgPlusCircleSmDark = function SvgPlusCircleSmDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#696969",
    cx: 12,
    cy: 12,
    r: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 13h5v-2h-5V6h-2v5H6v2h5v5h2v-5z",
    fill: "#696969"
  }))));
};

export default __webpack_public_path__ + "static/media/plus-circle-sm-dark.5f161feb.svg";
export { SvgPlusCircleSmDark as ReactComponent };